import { PayloadAction } from "@reduxjs/toolkit";
import { initialState } from "app/containers/Features/components/CommonTagSelection/redux/initialState";
import { createSlice } from "utils/@reduxjs/toolkit";
import { set } from "lodash";
import { ITags } from "../types";

const useClinicSlice = createSlice({
  name: "ticketTagsState",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setButtonLoading: (state, action: PayloadAction<boolean>) => {
      state.buttonLoading = action.payload;
    },
    updateFormValue: (
      state,
      action: PayloadAction<{ key: string; value: any }>,
    ) => {
      set(state, `form.${action.payload.key}`, action.payload.value);
    },
    clearForm: (state) => {
      state.form = initialState.form;
    },
    toggleDeleteModal: (state, action: PayloadAction<boolean>) => {
      state.deleteModal = action.payload;
    },
    setIsSelectedId: (state, action: PayloadAction<string>) => {
      state.selectedId = action.payload;
    },
    setFormValue: (state, action: PayloadAction<ITags>) => {
      state.form = action.payload;
    },
    createTags: (state, action: PayloadAction<{ callback: () => void }>) => {},
    updateTags: (state, action: PayloadAction<{ callback: () => void }>) => {},
    deleteTag: (
      state,
      action: PayloadAction<{ id: string; callback: () => void }>,
    ) => {},
  },
});
export const {
  actions,
  reducer: ticketTagsReducer,
  name: ticketTagsSlice,
} = useClinicSlice;
